<template>
  <v-dialog v-model="showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="dark">
        <v-btn icon dark @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>สินค้า</v-toolbar-title>
        <v-spacer></v-spacer>
        <!--
        <v-toolbar-items>
          <v-btn dark flat @click="save">Save</v-btn>
        </v-toolbar-items>
        -->
      </v-toolbar>
      <v-container fluid>
        <v-layout>
          <v-flex xs7 md8>
            <el-card class="box-card mb-3">
              <h3 class="title font-weight-black mb-3">เลือกร้าน</h3>
              <el-select
                v-model="selectedShopId"
                style="width:100%;"
                filterable
                placeholder="Select one shop"
                @change="onSelectShop(selectedShop)"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.shop_id"
                  :label="item.name"
                  :value="item.shop_id"
                ></el-option>
              </el-select>
              <!--
              <el-table stripe :data="shopList" style="width: 100%">
                <el-table-column label="Name" prop="name"></el-table-column>
                <el-table-column align="right">
                  <template slot-scope="props">
                    <el-button size="mini" type="danger" @click="onSelectShop(props.row)">Select</el-button>
                  </template>
                </el-table-column>
              </el-table>
              -->
            </el-card>
            <el-card class="box-card">
              <h3 class="title font-weight-black mb-3">Select Product</h3>
              <el-table stripe :data="productList" style="width:100%">
                <el-table-column label="Name" prop="name" width="280"></el-table-column>
                <el-table-column label="Price" prop="regular_price" width="100"></el-table-column>
                <el-table-column label="Status" prop="status" width="100"></el-table-column>
                <el-table-column align="right" label="Quantity">
                  <template slot-scope="props">
                    <el-input-number
                      size="small"
                      v-model="props.row.quantity"
                      @change="handleQuantityChanged(props.row)"
                      :min="0"
                      :max="1000"
                    ></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </v-flex>
          <v-flex xs5 md4 class="pl-3">
            <div class="sticky">
              <el-card class="box-card">
                <h3 class="title font-weight-black mb-3">Basket</h3>
                <el-row :gutter="10" v-for="(item, index) in basket" v-bind:key="index">
                  <el-col :span="2" class="mb-3">
                    <span>{{item.quantity}}x</span>
                  </el-col>
                  <el-col :span="12" class="mb-3">{{item.name}}</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{item.quantity*item.regular_price | numFormat('0,0')}}</el-col>
                </el-row>
                <div class="mt-3">
                  <el-button type="danger" size="small" class="el-btn-full" @click="save">Submit</el-button>
                </div>
              </el-card>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../services";

export default {
  name: "basket-dialog",
  props: {
    showDialog: { default: false },
    ent_id: { default: null }
  },
  data() {
    return {
      search: "",
      basket: [],
      shopList: [],
      productList: [],
      selectedShop: null,
      selectedShopId: null
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  created() {
    Service.Delivery.getShops().then(res => {
      this.shopList = res.data.filter(function(item) {
        return item.status == "published";
      });

      if (this.ent_id != null) {
        this.shopList = this.shopList.filter(item => {
          return item.ent_id == this.ent_id;
        });
      }
    });
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleQuantityChanged(row) {
      if (row.status == "published") {
        let index = this.basket.findIndex(x => x.product_id == row.product_id);
        if (index == -1) {
          //row.quantity++;
          this.basket.push(row);
        }
      } else {
        alert("this product not published.");
      }
    },
    onSelectShop() {
      this.showLoading();
      let row = this.shopList.find(x => x.shop_id == this.selectedShopId);
      this.selectedShop = row;
      Service.Delivery.getProductByShop(row.shop_id).then(res => {
        this.productList = res.data.map(item => {
          return { ...item, quantity: 0 };
        });

        this.hideLoading();
      });
    },
    onProductAdd(row) {
      if (row.status == "published") {
        let index = this.basket.findIndex(x => x.product_id == row.product_id);
        if (index == -1) {
          row.quantity++;
          this.basket.push(row);
        } else {
          if (this.basket[index].quantity < 1000) {
            this.basket[index].quantity++;
          }
        }
      } else {
        alert("this product not published.");
      }
    },
    onProductMinus(row) {
      if (row.status == "published") {
        let index = this.basket.findIndex(x => x.product_id == row.product_id);
        if (index != -1) {
          if (this.basket[index].quantity > 0) {
            this.basket[index].quantity--;
          }
          if (this.basket[index].quantity == 0) {
            this.basket.splice(index, 1);
          }
        }
      } else {
        alert("this product not published.");
      }
    },
    save() {
      let data = { basket: this.basket, shop: this.selectedShop };
      this.$emit("save", data);
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
    },
    hideLoading() {
      this.loading.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.quantity {
  margin: 0px 10px;
  font-weight: bold;
  font-size: 14px;
  width: 25px;
  text-align: center;
  display: inline-block;
}
</style>
